import "./UnitsKPI.css";

import { SelectData } from "../../../../models";
import { KanaTooltip, Select } from "../../..";

interface UnitsKPIProps {
  unitsKey: string | undefined;
  dropdownOptions: SelectData;
  title: string;
  showTooltip: boolean;
  onSelectChange: (value: string) => void;
}

export const UnitsKPI = ({
  unitsKey,
  dropdownOptions,
  title,
  showTooltip,
  onSelectChange,
}: UnitsKPIProps): JSX.Element => {
  return (
    <div className="UnitsKPI">
      <div className="UnitsKPIHeader">
        <div className="UnitsKPIHeaderAndIcon">
          <p className="body01">{title}</p>
          {showTooltip && (
            <KanaTooltip
              tooltipHeader="Inventory"
              tooltipText="Only issued units from projects where you are the registered developer are included in this figure"
            />
          )}
        </div>
        <Select className="UnitsKPISelect" data={dropdownOptions} onChange={onSelectChange} value={unitsKey} />
      </div>
      <div className="UnitsKPIFooter">
        <h1>{unitsKey?.split("-")[0]}</h1>
        <p className="body2">Total issued units</p>
      </div>
    </div>
  );
};
